import React, { useState, useEffect } from "react";
import "./Pages.css";
import { useHistory } from "react-router-dom";
import { Button, CircularProgress, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import StarRateIcon from "@mui/icons-material/StarRate";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import useBusinessQuery from "../../store/Bussiness/useBusinessQuery";
import useProfileQuery from "../../store/Profile/useProfileQuery";

const FB_COLOR = "#1877f2";
const IG_COLOR = "#e1306c";
const YT_COLOR = "#ff0000";

const BrandIcon = ({ color, letter }) => (
  <div style={{
    width: 26, height: 26, borderRadius: 8,
    background: color, display: "flex", alignItems: "center",
    justifyContent: "center", flexShrink: 0,
  }}>
    <span style={{ color: "#fff", fontSize: 13, fontWeight: 800 }}>{letter}</span>
  </div>
);

const EditSocial = () => {
  const history = useHistory();

  const [businessId, setBusinessId] = useState(null);
  const [registeredMobile, setRegisteredMobile] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [googleMaps, setGoogleMaps] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [googleReview, setGoogleReview] = useState("");
  const [youtube, setYoutube] = useState("");
  const [website, setWebsite] = useState("");

  const [saving, setSaving] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const { data: bizList, isSuccess: bizSuccess } = useBusinessQuery.Get_my_bussiness();
  const { mutateAsync: editBusiness } = useBusinessQuery.Edit_business();
  const { data: profileData } = useProfileQuery.Get_profile();

  useEffect(() => {
    if (profileData?.data?.mobile) {
      setRegisteredMobile(profileData.data.mobile);
    }
  }, [profileData]);

  useEffect(() => {
    if (bizList?.data?.results?.length > 0) {
      const biz = bizList.data.results[0];
      setBusinessId(biz.id);
      // Auto-fill WhatsApp from registered mobile if not set
      setWhatsapp(biz.whatsapp_number || profileData?.data?.mobile || "");
      setGoogleMaps(biz.google_location_link || "");
      setFacebook(biz.facebook || "");
      setInstagram(biz.instagram || "");
      setGoogleReview(biz.google_review_link || "");
      setYoutube(biz.youtube || "");
      setWebsite(biz.website || "");
    }
  }, [bizList, profileData]);

  const handleSave = async () => {
    if (!businessId) return;
    setSaving(true);
    try {
      const biz = bizList?.data?.results?.[0];
      const payload = {
        id: businessId,
        whatsapp_number: whatsapp,
        google_location_link: googleMaps,
        facebook,
        instagram,
        google_review_link: googleReview,
        youtube,
        website,
      };
      const carry = ["name","mobile_number","type","category","sub_category","district","post_office","pin_code","state","latitude","longitude","about_us","services_offered","image","banner_image","location_info"];
      carry.forEach(k => { if (biz?.[k]) payload[k] = biz[k]; });
      await editBusiness(payload);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2800);
    } finally {
      setSaving(false);
    }
  };

  const Row = ({ icon, placeholder, value, onChange, type = "text" }) => (
    <div className="pg-social-row">
      <div className="pg-social-icon-box">{icon}</div>
      <input
        className="pg-social-input"
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );

  return (
    <div className="pg-root">
      <div className="pg-topbar">
        <ArrowBackIcon
          onClick={() => history.push("/my-profile")}
          sx={{ color: "#0E3A53", cursor: "pointer", fontSize: 22 }}
        />
        <Typography className="pg-topbar-title">Social Media Information</Typography>
      </div>

      <div className="pg-body">
        <div className="pg-card">
          <Typography className="pg-card-title">
            <ShareOutlinedIcon /> Contact & Social Media
          </Typography>

          {/* Registered Mobile — read only */}
          <div className="pg-social-row">
            <div className="pg-social-icon-box">
              <PhoneAndroidOutlinedIcon sx={{ fontSize: 20, color: "#2182B1" }} />
            </div>
            <input
              className="pg-social-input"
              type="tel"
              value={registeredMobile}
              readOnly
              style={{ background: "#f4f6fb", color: "#6b7280", cursor: "not-allowed" }}
            />
            <div style={{ display: "flex", alignItems: "center", gap: 4, paddingRight: 8, flexShrink: 0 }}>
              <LockOutlinedIcon sx={{ fontSize: 14, color: "#9ab0be" }} />
              <span style={{ fontSize: 11, color: "#9ab0be", fontWeight: 600 }}>Registered</span>
            </div>
          </div>

          <Row
            icon={<WhatsAppIcon sx={{ fontSize: 20, color: "#25d366" }} />}
            placeholder="WhatsApp number (editable)"
            value={whatsapp}
            onChange={setWhatsapp}
            type="tel"
          />
          <Row
            icon={<LocationOnOutlinedIcon sx={{ fontSize: 20, color: "#ea4335" }} />}
            placeholder="Google Maps location link"
            value={googleMaps}
            onChange={setGoogleMaps}
          />
          <Row
            icon={<BrandIcon color={FB_COLOR} letter="f" />}
            placeholder="Facebook profile link"
            value={facebook}
            onChange={setFacebook}
          />
          <Row
            icon={<BrandIcon color={IG_COLOR} letter="ig" />}
            placeholder="Instagram profile link"
            value={instagram}
            onChange={setInstagram}
          />
          <Row
            icon={<StarRateIcon sx={{ fontSize: 22, color: "#fbbc04" }} />}
            placeholder="Google Review link"
            value={googleReview}
            onChange={setGoogleReview}
          />
          <Row
            icon={<BrandIcon color={YT_COLOR} letter="▶" />}
            placeholder="YouTube channel link"
            value={youtube}
            onChange={setYoutube}
          />
          <Row
            icon={<LanguageOutlinedIcon sx={{ fontSize: 20, color: "#0E3A53" }} />}
            placeholder="Website URL"
            value={website}
            onChange={setWebsite}
          />
        </div>
      </div>

      <div className="pg-save-bar">
        <Button className="pg-cancel-btn" onClick={() => history.push("/my-profile")}>
          Cancel
        </Button>
        <Button
          className="pg-save-btn"
          onClick={handleSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
        >
          {saving ? "Saving…" : "Save Changes"}
        </Button>
      </div>

      {showToast && (
        <div className="pg-toast">
          <CheckCircleIcon sx={{ fontSize: 16 }} /> Saved successfully
        </div>
      )}
    </div>
  );
};

export default EditSocial;
